import React from 'react'
import { ReactComponent } from './project-blueprint-buildings.svg'
import { MergeReactElementProps } from '../types'

interface BusinessCenterProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', BusinessCenterProps>

export const BusinessCenter = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill="none" ref={ref} {...props} />
  }
)
